import React, { useState, useEffect } from "react";
import Select from "react-select";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const AdminMessageForm = () => {
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [importance, setImportance] = useState("info");
  const [isGlobal, setIsGlobal] = useState(true);
  const [allUsers, setAllUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get("/api/users")
      .then((res) => {
        const options = res.data.map((user) => ({
          value: user.id,
          label: `${user.firstName} ${user.lastName}`,
        }));
        setAllUsers(options);
      })
      .catch((err) => console.error("Помилка завантаження користувачів", err));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (title.trim().length < 5) {
      alert(t("titleTooShort"));
      return;
    }
    if (content.trim().length < 20) {
      alert(t("contentTooShort"));
      return;
    }
    setLoading(true);

    try {
      const payload = {
        title,
        content,
        importance,
        is_global: isGlobal,
        driver_ids: isGlobal ? [] : selectedUsers.map((u) => u.value),
      };

      const token = localStorage.getItem("token");
      await axios.post("/api/create-message", payload, {
        headers: { Authorization: `Bearer ${token}` },
      }, { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } });

      alert(t("messageCreated"));
      navigate("/admin/messages/all");
      setTitle("");
      setContent("");
      setImportance("info");
      setIsGlobal(true);
      setSelectedUsers([]);
    } catch (err) {
      console.error("Помилка при створенні повідомлення", err);
      alert(t("messageCreationError"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4>{t("createMessage")}</h4>
        <a href="/admin/messages/all" className="btn btn-primary">
          {t("messages")}
        </a>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="form-group mb-2">
          <label>{t("messageTitle")}</label>

          <input
            className="form-control"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
            minLength={5}
          />
        </div>

        <div className="form-group mb-3">
          <label>{t("messageContent")}</label>
          <textarea
            className="form-control"
            value={content}
            onChange={(e) => setContent(e.target.value)}
            rows={6}
            required
            minLength={20}

          />
        </div>

        <div className="form-group mb-2">
          <label>{t("importance")}</label>
          <select
            className="form-select"
            value={importance}
            onChange={(e) => setImportance(e.target.value)}
          >
            <option value="info">{t("info")}</option>
            <option value="warning">{t("warning")}</option>
            <option value="danger">{t("danger")}</option>
            <option value="success">{t("success")}</option>
          </select>
          <div className="alert alert-info mt-3 mb-2">
            <strong>{t("importanceExplanation")}:</strong>
            <ul className="mb-0 mt-2 ps-3">
              <li>
                <span className="badge bg-info me-2">{t("info")}</span>
                — {t("infoDesc")}
              </li>
              <li>
                <span className="badge bg-warning text-dark me-2">{t("warning")}</span>
                — {t("warningDesc")}
              </li>
              <li>
                <span className="badge bg-danger me-2">{t("danger")}</span>
                — {t("dangerDesc")}
              </li>
              <li>
                <span className="badge bg-success me-2">{t("success")}</span>
                — {t("successDesc")}
              </li>
            </ul>
          </div>

        </div>

        <div className="form-check form-switch mb-3">
          <input
            className="form-check-input"
            type="checkbox"
            checked={isGlobal}
            onChange={() => setIsGlobal(!isGlobal)}
            id="isGlobalSwitch"
          />
          <label className="form-check-label" htmlFor="isGlobalSwitch">
            {t("sendToAll")}
          </label>
        </div>

        {!isGlobal && (
          <div className="form-group mb-3">
            <label>{t("chooseUsers")}</label>
            <Select
              isMulti
              options={allUsers}
              value={selectedUsers}
              onChange={setSelectedUsers}
            />
          </div>
        )}

        <button className="btn btn-primary" type="submit" disabled={loading}>
          {loading ? t("sending") : t("send")}
        </button>
      </form>

    </div>
  );
};

export default AdminMessageForm;
